import React from "react";
import { useTableSearch } from "../../../hooks/useTableSearch";
import useSortableData from "../../../hooks/useSortableData";
import { Icon } from "@iconify/react";
import {
  Button,
  Grid,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { contractMemberTypeList } from "../members/NewMemberDialogSteps/memberTypes";
import MemberTypeCard from "../members/NewMemberDialogSteps/MemberTypeCard";
import Loading from "../../../components/spinners/Loading";

const classes = {
  root: {},
  table: {
    minWidth: 700,
  },
  tableHeadButton: {
    width: "180px",
    fontSize: "1.2rem",
  },
  tableRow: {
    "&$hover:hover": {
      cursor: "pointer",
    },
    "&$selected, &$selected:hover": {
      backgroundColor: "#304ffe",
    },
  },
  tableCell: {
    fontSize: "1.2rem",
  },
};

export default function ContractTable({ contracts, onSubmit }) {
  const [selectedContract, setSelectedContract] = React.useState(null);
  const [showNext, setShowNext] = React.useState(false);
  const [searchVal, setSearchVal] = React.useState(null);
  const { filteredData, loading } = useTableSearch({
    searchVal,
    inputData: contracts,
  });
  const { items, requestSort, sortConfig } = useSortableData(filteredData);

  let tableDataToRender = items;

  const getSortIcon = (name) => {
    if (sortConfig?.key === name) {
      if (sortConfig?.direction === "ascending") {
        return <Icon icon="mdi:arrow-up" />;
      } else {
        return <Icon icon="mdi:arrow-down" />;
      }
    } else {
      return null;
    }
  };

  const handleSelectRow = (vn) => {
    setSelectedContract(vn);
  };

  const handleContinue = () => {
    setShowNext(true);
  };

  const handleFinish = (type) => {
    onSubmit(selectedContract, type);
  };

  const vertragsnehmerData = tableDataToRender.map((vn, i) => {
    return (
      <TableRow
        hover
        onClick={() => {
          handleSelectRow(vn);
        }}
        sx={{ cursor: "pointer" }}
        selected={vn?._id === selectedContract?._id}
        key={`${vn.lastName}--${i}`}
      >
        <TableCell style={classes.tableCell} align="left">
          {vn.title}
        </TableCell>
        <TableCell style={classes.tableCell} align="left">
          {vn.lastName}
        </TableCell>
        <TableCell style={classes.tableCell} align="left">
          {vn.firstName}
        </TableCell>
      </TableRow>
    );
  });

  let previewContractPersonData = (
    <div style={{ textAlign: "left" }}>
      <h3>Vertragsperson</h3>
      <table>
        <tr>
          <th>Anrede: </th>
          <td>{selectedContract && selectedContract.title}</td>
        </tr>
        <tr>
          <th>Nachname: </th>
          <td>{selectedContract && selectedContract.lastName}</td>
        </tr>
        <tr>
          <th>Vorname: </th>
          <td>{selectedContract && selectedContract.firstName}</td>
        </tr>
        <tr>
          <th>Geburtsdatum: </th>
          <td>
            {selectedContract &&
              new Date(selectedContract.birthdate).toLocaleDateString()}
          </td>
        </tr>
      </table>
    </div>
  );

  if (showNext) {
    return (
      <div style={{ padding: "50px" }}>
        <Grid
          container
          direction="row"
          justifyContent={"space-between"}
          spacing={3}
        >
          {contractMemberTypeList &&
            contractMemberTypeList.map((memberType, i) => {
              return (
                <Grid
                  item
                  style={{ display: "flex" }}
                  justify="center"
                  key={i}
                  lg={4}
                  xs={12}
                >
                  <MemberTypeCard memberType={memberType}>
                    <Button
                      color="secondary"
                      variant="contained"
                      style={{ width: "100%", minHeight: "60px", fontSize: 20 }}
                      onClick={() => handleFinish(memberType.type)}
                    >
                      Auswählen
                    </Button>
                  </MemberTypeCard>
                </Grid>
              );
            })}
        </Grid>
      </div>
    );
  } else {
    return (
      <div>
        <Grid container lg={12} xs={12}>
          <Grid item lg={7} xs={12}>
            <TableContainer
              style={{ overflow: "auto", height: "500px", fontSize: "1.2rem" }}
              component={Paper}
            >
              <TextField
                style={{ marginLeft: "24px" }}
                id="standard-basic"
                label="Suchen"
                variant="standard"
                onChange={(e) => setSearchVal(e.target.value)}
                placeholder="Suchen"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="end">
                      <Icon icon="mdi:search" />
                    </InputAdornment>
                  ),
                }}
              />
              <Table stickyHeader size="small" aria-label="simple table">
                <TableHead>
                  <TableRow>
                    {[
                      { label: "Anrede", value: "title" },
                      { label: "Nachname", value: "lastName" },
                      { label: "Vorname", value: "firstName" },
                    ].map((cell) => (
                      <TableCell
                        sx={{ cursor: "pointer", color: "black", padding: 1 }}
                        onClick={() => requestSort(cell.value)}
                        style={classes.tableHeadButton}
                        align="left"
                      >
                        {cell.label}
                        {getSortIcon(cell.value)}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                {loading ? (
                  <Loading />
                ) : (
                  <TableBody>{vertragsnehmerData}</TableBody>
                )}
              </Table>
            </TableContainer>
          </Grid>
          <Grid
            style={{ display: "flex", paddingLeft: "24px" }}
            item
            lg={5}
            xs={12}
          >
            <div
              style={{
                flex: "1 0 auto",
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
              }}
            >
              <div>
                <Typography variant="h4">Ausgewählter Vertrag:</Typography>
                {previewContractPersonData}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Button
                  color="secondary"
                  variant="contained"
                  disabled={selectedContract === null}
                  style={{ width: "100%", minHeight: "60px", fontSize: 20 }}
                  onClick={handleContinue}
                >
                  Auswählen
                </Button>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}
